import { z } from 'zod';

// Per-widget config for progress-snapshot widgets. Only `timeframe` lives here — filters
// and scope live on the parent dashboard and apply uniformly to every widget on it.

// Valid `timeframe` tokens. Frontend imports the same constant for the dropdown picker
// + the dateRange computation, so the wire format stays in sync with the UI.
export const progressTimeframes = ['2w', '1m', '3m', '6m', '1y', 'oldest'] as const;
export const progressTimeframeSchema = z.enum(progressTimeframes);
export type ProgressTimeframe = z.infer<typeof progressTimeframeSchema>;

export const DEFAULT_PROGRESS_TIMEFRAME: ProgressTimeframe = '3m';

export const progressSnapshotConfigDTOSchema = z.object({
  widgetId: z.number().int(),
  timeframe: progressTimeframeSchema,
});

export type ProgressSnapshotConfigDTO = z.infer<typeof progressSnapshotConfigDTOSchema>;

export function parseProgressSnapshotConfigDTO(data: unknown): ProgressSnapshotConfigDTO {
  return progressSnapshotConfigDTOSchema.parse(data);
}

export const progressSnapshotConfigUpsertDTOSchema = progressSnapshotConfigDTOSchema
  .omit({ widgetId: true })
  .strict();

export type ProgressSnapshotConfigUpsertDTO = z.infer<typeof progressSnapshotConfigUpsertDTOSchema>;
